import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from '@progress/kendo-react-buttons';
import { alertService } from '../../services/helpers/alert.service';
import { useNavigate } from "react-router-dom";

export const Alert = (props) => {
    const [open, setOpen] = useState(true);
   

    const [obsAlert, setObsAlert] = useState({});

    useEffect(() => {
        alertService.observable.subscribe(x => {
            setObsAlert(x);
        })
    }, []);

    const onClose = () => {
        alertService.close();
    }

    const onConfirm = () => {
        obsAlert.onConfirm();
        alertService.close();
    }

    const onCancel = () => {
        obsAlert.onCancel();
        alertService.close();
    }

    return (<>
        {obsAlert.show && <AlertDialog title={obsAlert.title} message={obsAlert.message} onClose={onClose} onConfirm={onConfirm} onCancel={onCancel} type={obsAlert.type} />}
    </>);
};

const AlertDialog = (props) => {
    let title = props.title ? props.title : 'Atentie!';
    let message = props.message ? props.message : 'A intervenit o eroare. Va rugam reincercati.';

    const navigate = useNavigate();

    useEffect(() => {
        if (message.toLowerCase().indexOf("frauda") > -1) {
            sessionStorage.clear();
            navigate('/');
        }
    })

    return (<>
        <Dialog title={title} onClose={props.onClose}>
            <div>
                {message}
            </div>
            <DialogActionsBar>
                
                {props.type == "info" && <Button themeColor={"primary"} onClick={props.onClose}>Ok</Button>}
                {props.type == "confirm" && <>
                    <Button themeColor={"primary"} onClick={props.onConfirm}>Da</Button>
                    <Button themeColor={"primary"} onClick={props.onCancel}>Nu</Button>
                </>}
            </DialogActionsBar>
        </Dialog>
    </>);
};
